import { FormattedMessage } from "react-intl";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import ContentLoading from "component/LoadingComponent/ContentLoading.js";
import LabelLang from "component/LabelLang/label-lang.js";
import { useVersionsData } from "./useVersionsData";
import PublicationIntro from "./components/PublicationIntro";
import DownloadButtons from "./components/DownloadButtons";
import ShareButtons from "./components/ShareButtons";
import PublicationActions from "./components/PublicationActions";
import PeriodFilters from "./components/PeriodFilters";
import PublicationMeta from "./components/PublicationMeta";
import RelatedPublications from "./components/RelatedPublications";
import "./Versions.scss";

function Versions() {
  const {
    dir,
    currentLocale,
    isLoading,
    publication,
    relatedPublications,
    selectYear,
    selectMonth,
    selectQuarter,
    setSelectMonth,
    setSelectQuarter,
    handleYearChange,
    uniqueRenderYears,
    renderedMonths,
    renderedQuarters,
    renderedHalfs,
    searchDetails,
    preparingPDFFile,
    preparingExcelFile,
    showPdfFiles,
    showExcelFiles,
    setShowPdfFiles,
    setShowExcelFiles,
    onExport,
  } = useVersionsData();

  const hasName =
    publication?.name !== null && publication?.name !== undefined;

  return (
    <ContentLoading isLoading={isLoading}>
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="publications" />,
            clickClass: false,
          },
          {
            title: hasName ? (
              <LabelLang
                id="name"
                defaultValue={publication.name}
                translations={publication.publicationTranslations}
              />
            ) : (
              <FormattedMessage id="data-not-found" />
            ),
            clickClass: true,
          },
        ]}
        title={<FormattedMessage id="browse-publications" />}
        route={"../publications"}
      />

      <div className="media-landing-news-Item">
        <div className="container">
          <div className="row gy-4 py-4">
            <div className="col-12 col-lg-9">
              <PublicationIntro
                publication={publication}
                currentLocale={currentLocale}
              />

              <div className="row gy-4">
                <div className="col-12 col-lg-6">
                  <DownloadButtons
                    searchDetails={searchDetails}
                    publication={publication}
                    currentLocale={currentLocale}
                    preparingPDFFile={preparingPDFFile}
                    preparingExcelFile={preparingExcelFile}
                    showPdfFiles={showPdfFiles}
                    showExcelFiles={showExcelFiles}
                    setShowPdfFiles={setShowPdfFiles}
                    setShowExcelFiles={setShowExcelFiles}
                    onExport={onExport}
                  />
                  <br />
                  <ShareButtons publication={publication} />
                </div>
                <div className="col-lg-2" />
                <PublicationActions
                  publication={publication}
                  searchDetails={searchDetails}
                  currentLocale={currentLocale}
                />
              </div>

              <br />
              <PeriodFilters
                dir={dir}
                currentLocale={currentLocale}
                publication={publication}
                selectYear={selectYear}
                selectMonth={selectMonth}
                selectQuarter={selectQuarter}
                uniqueRenderYears={uniqueRenderYears}
                renderedMonths={renderedMonths}
                renderedQuarters={renderedQuarters}
                renderedHalfs={renderedHalfs}
                handleYearChange={handleYearChange}
                setSelectMonth={setSelectMonth}
                setSelectQuarter={setSelectQuarter}
              />
            </div>

            <div className="col-12 col-lg-3">
              <PublicationMeta
                publication={publication}
                searchDetails={searchDetails}
              />
              <RelatedPublications
                relatedPublications={relatedPublications}
                currentLocale={currentLocale}
              />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default Versions;
